module.exports = __webpack_public_path__ + "static/media/7.62cc5da2.jpg";